import React from 'react';

export const JCBLogo = () => {
  return (
    <svg
      width="31"
      height="20"
      viewBox="0 0 31 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M27.6047 15.3232C27.6047 17.4533 25.868 19.19 23.7379 19.19H2.68652V3.86678C2.68652 1.73669 4.42322 0 6.55331 0H27.6047V15.3232Z"
          fill="white"
        />
        <path
          d="M20.7539 11.3884H22.3563C22.4043 11.3884 22.5098 11.3692 22.5578 11.3692C22.8648 11.3116 23.1239 11.0333 23.1239 10.6495C23.1239 10.2849 22.8648 10.0067 22.5578 9.92991C22.5098 9.91072 22.4234 9.91072 22.3563 9.91072H20.7539V11.3884Z"
          fill="url(#paint0_linear)"
        />
        <path
          d="M22.1643 1.29536C20.6387 1.29536 19.3913 2.53312 19.3913 4.06832V6.94682H23.3061C23.402 6.94682 23.5076 6.94682 23.5843 6.96601C24.4671 7.01398 25.1195 7.46495 25.1195 8.26133C25.1195 8.88501 24.6782 9.42233 23.853 9.52787V9.55666C24.7549 9.61423 25.4362 10.1228 25.4362 10.9C25.4362 11.7347 24.6782 12.2816 23.6707 12.2816H19.3817V17.9139H23.45C24.9756 17.9139 26.223 16.6761 26.223 15.1409V1.29536H22.1643Z"
          fill="url(#paint1_linear)"
        />
        <path
          d="M22.9124 8.43367C22.9124 8.06906 22.6533 7.82919 22.3463 7.78121C22.3175 7.78121 22.2407 7.76202 22.1927 7.76202H20.7439V9.10532H22.1927C22.2407 9.10532 22.3271 9.10532 22.3463 9.08613C22.6533 9.04775 22.9124 8.79828 22.9124 8.43367Z"
          fill="url(#paint2_linear)"
        />
        <path
          d="M6.84085 1.29536C5.31524 1.29536 4.0679 2.53312 4.0679 4.06832V10.9096C4.84509 11.2934 5.65107 11.5332 6.45705 11.5332C7.41655 11.5332 7.93468 10.9575 7.93468 10.1611V6.92763H10.3142V10.142C10.3142 11.3893 9.53704 12.416 6.89842 12.416C5.29605 12.416 4.04871 12.061 4.04871 12.061V17.8947H8.11698C9.64258 17.8947 10.8899 16.657 10.8899 15.1218V1.29536C10.8995 1.29536 6.84085 1.29536 6.84085 1.29536Z"
          fill="url(#paint3_linear)"
        />
        <path
          d="M14.5077 1.29536C12.9821 1.29536 11.7347 2.53312 11.7347 4.06832V7.69523C12.4352 7.10034 13.6537 6.71654 15.6207 6.81249C16.6762 6.86047 17.7988 7.14832 17.7988 7.14832V8.31891C17.2327 8.03106 16.561 7.77199 15.6975 7.71442C14.2007 7.60888 13.3083 8.3381 13.3083 9.61423C13.3083 10.9096 14.2103 11.6388 15.6975 11.514C16.561 11.4565 17.2327 11.1782 17.7988 10.9096V12.0801C17.7988 12.0801 16.6858 12.368 15.6207 12.416C13.6537 12.5119 12.4352 12.1281 11.7347 11.5332V17.9331H15.803C17.3286 17.9331 18.576 16.6953 18.576 15.1601V1.29536H14.5077Z"
          fill="url(#paint4_linear)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="19.3914"
          y1="10.6603"
          x2="26.2354"
          y2="10.6603"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#007940" />
          <stop offset="0.2285" stopColor="#00873F" />
          <stop offset="0.7433" stopColor="#40A737" />
          <stop offset="1" stopColor="#5CB531" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="19.3911"
          y1="9.60272"
          x2="26.2294"
          y2="9.60272"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#007940" />
          <stop offset="0.2285" stopColor="#00873F" />
          <stop offset="0.7433" stopColor="#40A737" />
          <stop offset="1" stopColor="#5CB531" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="19.3908"
          y1="8.43726"
          x2="26.2351"
          y2="8.43726"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#007940" />
          <stop offset="0.2285" stopColor="#00873F" />
          <stop offset="0.7433" stopColor="#40A737" />
          <stop offset="1" stopColor="#5CB531" />
        </linearGradient>
        <linearGradient
          id="paint3_linear"
          x1="4.06892"
          y1="9.59511"
          x2="11.0189"
          y2="9.59511"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1F286F" />
          <stop offset="0.4751" stopColor="#004E94" />
          <stop offset="0.8261" stopColor="#0066B1" />
          <stop offset="1" stopColor="#006FBC" />
        </linearGradient>
        <linearGradient
          id="paint4_linear"
          x1="11.694"
          y1="9.61035"
          x2="18.444"
          y2="9.61035"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6C2C2F" />
          <stop offset="0.1735" stopColor="#882730" />
          <stop offset="0.5731" stopColor="#BE1833" />
          <stop offset="0.8585" stopColor="#DC0436" />
          <stop offset="1" stopColor="#E60039" />
        </linearGradient>
        <clipPath id="clip0">
          <rect width="30.2242" height="19.19" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
